/*
 * BL-plp-basin-swap.js
 * PLP (collection) image swap para Washbasin v3.
 * Lee los filtros nativos de senos (basin_config) y faldon (basin_thickness) desde la URL
 * y sustituye la imagen de cada card por la del mapa product.metafields.custom.furniture_basin_image_filter,
 * emitido por card-product.liquid en data-bl-basin-map (clave "color|grosor|senos|con" -> url; la card
 * enseña siempre la version con agujero, y una clave antigua de 3 valores vale como "con").
 * Regla: color -> imagen principal; senos/faldon -> imagen asociada.
 * Config inyectada por snippets/BL-plp-basin-swap.liquid en window.BLPlpBasin.
 */
(function () {
  'use strict';
  var CFG = window.BLPlpBasin || {};
  var SENOS = CFG.senos || {};      // { 'gid://...': '1'|'2' }
  var FALDON = CFG.faldon || {};    // { 'gid://...': '2'|'6'|'10' }
  var BASIN_COLOR = CFG.basinColor || 'weiss';
  var DEFAULT_KEY = CFG.collectionDefault || ''; // "color|grosor|senos" o ''

  function parseDefault() {
    if (!DEFAULT_KEY) return null;
    var p = DEFAULT_KEY.split('|');
    if (p.length !== 3 && p.length !== 4) return null;
    return { color: p[0], faldon: p[1], senos: p[2] };
  }

  // Devuelve senos/faldon activos leyendo CUALQUIER valor de la query que matchee un GID conocido.
  function activeFromUrl() {
    var s = null, f = null;
    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (val) {
        if (SENOS[val] != null) s = SENOS[val];
        if (FALDON[val] != null) f = FALDON[val];
      });
    } catch (e) { /* noop */ }
    return { s: s, f: f };
  }

  // Clave final del mapa, o null para mostrar la imagen principal.
  function resolveKey() {
    var act = activeFromUrl();
    var def = parseDefault();
    if (act.s == null && act.f == null) {
      // Sin filtro de senos/faldon -> default de coleccion si existe, si no principal.
      return DEFAULT_KEY || null;
    }
    var faldon = act.f != null ? act.f : (def ? def.faldon : '2');
    var senos = act.s != null ? act.s : (def ? def.senos : '1');
    var color = def ? def.color : BASIN_COLOR;
    return color + '|' + faldon + '|' + senos;
  }

  function apply() {
    var key = resolveKey();
    var act = activeFromUrl();
    var urlDriven = act.s != null || act.f != null;
    var wraps = document.querySelectorAll('[data-bl-basin-map]');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      // 2026-09-23 (barra de combinaciones): la card trae su propia clave (la combinacion mas barata
      // que calculo card-product.liquid). Sin filtro de senos/faldon en la URL manda esa; antes el
      // swap volvia a la principal y deshacia la foto que el servidor ya habia puesto.
      var cardKey = wrap.getAttribute('data-bl-card-key');
      var k = (!urlDriven && cardKey) ? cardKey : key;
      var img = wrap.querySelector('img.bl-basin-img') || wrap.querySelector('img');
      if (!img) continue;
      var map;
      try { map = JSON.parse(wrap.getAttribute('data-bl-basin-map')); } catch (e) { continue; }
      var principal = wrap.getAttribute('data-bl-principal') || '';
      var url = k ? (map[k + '|con'] || map[k]) : null;
      if (!url && principal) url = principal; // sin clave, o clave inexistente -> principal
      if (!url) continue;
      // 2026-09-30 (tablero de fotos): la card que pide otra foto en movil/tablet/portatil trae <source data-bl-alt>
      // y su mapa propio (data-bl-basin-map-alt); el <source> manda sobre el <img> en ese ancho.
      setAlt(wrap, k);
      if (img.getAttribute('src') === url && img.getAttribute('srcset') === url) continue;
      img.setAttribute('src', url);
      img.setAttribute('srcset', url); // anula el srcset responsive del tema
      try { img.srcset = url; img.src = url; } catch (e) { /* noop */ }
    }
  }

  function setAlt(wrap, k) {
    var raw = wrap.getAttribute('data-bl-basin-map-alt');
    if (!raw) return;
    var amap;
    try { amap = JSON.parse(raw); } catch (e) { return; }
    var url = k ? (amap[k + '|con'] || amap[k]) : null;
    if (!url) url = wrap.getAttribute('data-bl-principal-alt') || '';
    if (!url) return;
    var srcs = wrap.querySelectorAll('source[data-bl-alt]');
    for (var j = 0; j < srcs.length; j++) {
      if (srcs[j].getAttribute('srcset') !== url) srcs[j].setAttribute('srcset', url);
    }
  }

  var raf = null;
  function scheduleApply() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  }

  function init() {
    apply();
    window.addEventListener('popstate', scheduleApply);
    // Las facetas del tema re-renderizan #ProductGridContainer vía AJAX -> re-aplicar.
    var container = document.getElementById('ProductGridContainer') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(scheduleApply).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
